import React from 'react'
import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons'
import { Texto } from '@gravitate-js/excalibrr'

export const DifferenceCell = ({
  comparisonAverages,
  metricType,
  metricKey,
  data,
  value,
  comparisonKey,
  isPercent,
}) => {
  let averageRow
  if (comparisonKey === 'system') {
    averageRow = comparisonAverages?.[0]
  } else {
    averageRow = comparisonAverages?.find((item) => item.name === data[comparisonKey])
  }

  const diff = averageRow ? data[metricType][metricKey] - averageRow[metricType][metricKey] : 0
  const difference = diff.toFixed(3) > 0 || diff.toFixed(3) < 0 ? diff : 0
  if (!value && !difference) {
    return (
      <Texto align={'right'} category='p2' weight={600}>
        0
      </Texto>
    )
  }

  return <DiffDisplay isPercent={isPercent} value={value} difference={difference} />
}
export const DiffDisplay = ({ value, difference, isPercent }) => {
  const showDifference = !!difference && difference !== 0
  return (
    <div className='flex items-end justify-end'>
      <Texto category='p2' weight={600}>
        {isPercent ? `${(value * 100).toFixed(1)}%` : value?.toLocaleString('en')}
      </Texto>
      {showDifference && (
        <Texto category='label' appearance={difference > 0 ? 'success' : 'error'} weight={600}>
          {difference > 0 ? <CaretUpFilled className='pl-2' /> : <CaretDownFilled className='pl-2' />}
          {difference > 0 ? '+' : ''} {difference.toLocaleString('en')}
        </Texto>
      )}
    </div>
  )
}
